export default {"src":"/fly/_next/static/media/co.ffea6c22.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};